// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export function _createData(baseType, data) {
    return {
        baseType: baseType,
        baseData: data,
        aiDataContract: {
            baseType: 1 /* FieldType.Required */,
            baseData: 1 /* FieldType.Required */
        }
    };
}
//# sourceMappingURL=Data.js.map